<!-- Menu movil, propuesta 3 "el actual pulido" (2026-10-21): pagina actual en azul con punto, flechas en circulo,
     Portal como boton de contorno y Cotizar debajo; sin selector de idioma ni redes (sin URLs oficiales todavia). -->
<div class="mobile-home-menu-mobile mm3">
  <div class="mm3-top">
    <img (click)="goHome()" alt="Blue Assist" src="/assets/external/mobile/vectori2776-m31m.svg" class="mm3-logo" />
  </div>
  <nav class="mm3-nav" aria-label="Menú principal">
    <button type="button" class="mm3-link" [class.on]="isActive('home')" [attr.aria-current]="isActive('home') ? 'page' : null" (click)="goHome()"><span class="mm3-label"><span class="mm3-dot"></span>Home</span><span class="mm3-chev" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></span></button>
    <button type="button" class="mm3-link" [class.on]="isActive('about-us')" [attr.aria-current]="isActive('about-us') ? 'page' : null" (click)="goAboutUs()"><span class="mm3-label"><span class="mm3-dot"></span>Nosotros</span><span class="mm3-chev" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></span></button>
    <button type="button" class="mm3-link" [class.on]="isActive('insured')" [attr.aria-current]="isActive('insured') ? 'page' : null" (click)="goInsured()"><span class="mm3-label"><span class="mm3-dot"></span>Viajeros</span><span class="mm3-chev" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></span></button>
  </nav>
  <div class="mm3-actions">
    <button type="button" class="mm3-portal" (click)="goPortalLogin()"><img src="/assets/external/mobile/component3i2776-ynwv.svg" alt="" />Acceso al Portal</button>
    <button type="button" class="mm3-cta" (click)="goQuote()">Cotizar Seguro</button>
  </div>
  <div class="mm3-foot">
    <a class="mm3-priv" (click)="goPrivacy()">Política de privacidad</a>
    <p>All rights reserved by BAC Financial Services.</p>
    <p>Diseño y desarrollo por <a class="mm3-wm" href="https://www.wemarkforyou.com" target="_blank" rel="noopener">wemarkforyou.com</a></p>
  </div>
</div>
<!-- menu anterior (hasta 2026-10-21)
<div class="mobile-home-menu-mobile">
  <ul>
    <li style="padding: 0 1rem;">
      <img  (click)="goHome()"
      alt="VectorI2776"
      src="/assets/external/mobile/vectori2776-m31m.svg"
      class="mobile-home-vector2"
    />
    <div class="cotizar-btn"  (click)="goQuote()">
      <span class="Mob,H1,Bold,12">
        <span>Cotizar Seguro</span>
      </span>
    </div>
    </li>
   <!- - selector de idioma oculto (2026-10-21, a peticion: aun no hay version en ingles)
   <li class="leng">
    <div class="mobile-menu">
      <span class="mobile-home-text63 Mob,P3,Regular12 d-flex align-items-center">
        <a href="#">ENG</a>
        <a href="#" class="active">ESP</a>
      </span>
      
    </div>
   </li>
   - ->
    <li class="menu-link">
      <div class=" mobile-menu" (click)="goHome()">
        <span class="mobile-home-text63 Mob,P3,Regular12">
          <span>Home</span>
        </span>
        <img
          alt="DropdownI2776"
          src="/assets/external/mobile/dropdowni2776-pt2j.svg"
          class="mobile-home-dropdown1 drop-arrow"
        />
      </div>
    </li>
    <li class="menu-link">
      <div class=" mobile-menu" (click)="goAboutUs()">
        <span class="mobile-home-text61 Mob,P3,Regular12">
          <span>Nosotros</span>
        </span>
        <img
          alt="DropdownI2776"
          src="/assets/external/mobile/dropdowni2776-o7p.svg"
          class="mobile-home-dropdown drop-arrow"
        />
      </div>
      </li>
      
    <li class="menu-link">
      <div class="mobile-menu" (click)="goInsured()">
        <span class="mobile-home-text65 Mob,P3,Regular12">
          <span>Viajeros</span>
        </span>
        <img
          alt="DropdownI2776"
          src="/assets/external/mobile/dropdowni2776-kdk5.svg"
          class="mobile-home-dropdown2 drop-arrow"
        />
      </div>
    </li>
    <!- - <li class="menu-link">
      <div class="mobile-menu" (click)="goBlog()">
        <span class="mobile-home-text67 Mob,P3,Regular12">
          <span>Blog</span>
        </span>
        <img
          alt="DropdownI2776"
          src="/assets/external/mobile/dropdowni2776-wgl.svg"
          class="mobile-home-dropdown3 drop-arrow"
        />
      </div>
    </li> - ->
    <li class="menu-link mobile-home-log-box" (click)="goPortalLogin()">
      <div class="mobile-home-log">
        <img
          alt="Component3I2776"
          src="/assets/external/mobile/component3i2776-ynwv.svg"
          class="mobile-home-component3"
        />
        <div class="mobile-home-frame79">
          <span class="mobile-home-text71 Mob,H3,Medium12">
            <span>Acceso al Portal</span>
          </span>
        </div>
      </div>
      <img
        alt="DropdownI2776"
        src="/assets/external/mobile/dropdowni2776-wgl.svg"
        class="mobile-home-dropdown3 drop-arrow cliente-arrow"
      />
    </li>
  </ul>
  <div class="menu-footer">
    <div class="menu-social-link">
      <img
      alt="Facebook2776"
      src="/assets/external/mobile/facebook2776-855.svg"
      class="facebook"
    />
    <div class="linkdin">
      <div class="mobile-home-group1018">
        <img
          alt="VectorI2776"
          src="/assets/external/mobile/vectori2776-7k4l.svg"
          class="mobile-home-vector"
        />
        <img
          alt="VectorI2776"
          src="/assets/external/mobile/vectori2776-kqv8.svg"
          class="mobile-home-vector1"
        />
      </div>
    </div>
    <div class="instagram">
      <img
        alt="ExcludeI2776"
        src="/assets/external/mobile/excludei2776-3ie.svg"
        class="mobile-home-exclude"
      />
    </div>
  </div>
    <div class="menu-copy-right">
      
      <span class="Mob,P4,Intro,Light,10">
        <span class="blue-bold">Politica de privacidad</span>
        All rights reserved by BAC Financial Services. 
Design by Wemark | <a href="https://www.wemarkforyou.com" target="_blank">www.wemarkforyou.com</a>
      </span>
    </div>
  </div>
</div>
-->
<!-- <div class="mobile-home-menu-mobile">
  <img
    alt="Facebook2776"
    src="/assets/external/mobile/facebook2776-855.svg"
    class="mobile-home-facebook"
  />
  <div class="mobile-home-linkdin">
    <div class="mobile-home-group1018">
      <img
        alt="VectorI2776"
        src="/assets/external/mobile/vectori2776-7k4l.svg"
        class="mobile-home-vector"
      />
      <img
        alt="VectorI2776"
        src="/assets/external/mobile/vectori2776-kqv8.svg"
        class="mobile-home-vector1"
      />
    </div>
  </div>
  <div class="mobile-home-instagram">
    <img
      alt="ExcludeI2776"
      src="/assets/external/mobile/excludei2776-3ie.svg"
      class="mobile-home-exclude"
    />
  </div>
  <div class="mobile-home-cotizar"  (click)="goQuote()">
    <span class="mobile-home-text59 Mob,H1,Bold,14">
      <span>Cotizar</span>
    </span>
  </div>
  <img
    alt="Line1042776"
    src="/assets/external/mobile/line1042776-ico.svg"
    class="mobile-home-line104"
  />
  <img
    alt="Line1052776"
    src="/assets/external/mobile/line1052776-avp.svg"
    class="mobile-home-line105"
  />
  <img
    alt="Line1062776"
    src="/assets/external/mobile/line1062776-zemn.svg"
    class="mobile-home-line106"
  />
  <img
    alt="Line1092776"
    src="/assets/external/mobile/line1092776-4nyo.svg"
    class="mobile-home-line109"
  />
  <img
    alt="Line1102776"
    src="/assets/external/mobile/line1102776-bb8s.svg"
    class="mobile-home-line110"
  />
  <img
    alt="Line1032776"
    src="/assets/external/mobile/line1032776-1ov.svg"
    class="mobile-home-line103"
  />
  <img
    alt="BallPink12776"
    src="/assets/external/mobile/ballpink12776-hhcb-200w.png"
    class="mobile-home-ball-pink1"
  />
  <img
    alt="PillBlue12776"
    src="/assets/external/mobile/pillblue12776-hv6-400w.png"
    class="mobile-home-pill-blue1"
  />
  <div class=" mobile-menu" (click)="goAboutUs()">
    <span class="mobile-home-text61 Mob,P3,Regular12">
      <span>Nosotros</span>
    </span>
    <img
      alt="DropdownI2776"
      src="/assets/external/mobile/dropdowni2776-o7p.svg"
      class="mobile-home-dropdown"
    />
  </div>
  <div class=" mobile-menu" (click)="goBenefits()">
    <span class="mobile-home-text63 Mob,P3,Regular12">
      <span>Beneficios</span>
    </span>
    <img
      alt="DropdownI2776"
      src="/assets/external/mobile/dropdowni2776-pt2j.svg"
      class="mobile-home-dropdown1"
    />
  </div>
  <div class="mobile-home-asegurados-mobile mobile-menu" (click)="goInsured()">
    <span class="mobile-home-text65 Mob,P3,Regular12">
      <span>Asegurados</span>
    </span>
    <img
      alt="DropdownI2776"
      src="/assets/external/mobile/dropdowni2776-kdk5.svg"
      class="mobile-home-dropdown2"
    />
  </div>
  <div class="mobile-home-blog-mobile mobile-menu" (click)="goBlog()">
    <span class="mobile-home-text67 Mob,P3,Regular12">
      <span>Blog</span>
    </span>
    <img
      alt="DropdownI2776"
      src="/assets/external/mobile/dropdowni2776-wgl.svg"
      class="mobile-home-dropdown3"
    />
  </div>
  <div class="mobile-home-particula1 mobile-menu">
    <img
      alt="SphereWhite2I2776"
      src="/assets/external/mobile/spherewhite2i2776-1v39-200h.png"
      class="mobile-home-sphere-white22"
    />
  </div>
  <span class="mobile-home-text69 Mob,P4,Intro,Light,10">
    <span>
      All rights reserved by BAC Financial Services. | Política de
      privacidad | Design by Wemark.
    </span>
  </span>
  <div class="mobile-home-log">
    <img
      alt="Component3I2776"
      src="/assets/external/mobile/component3i2776-ynwv.svg"
      class="mobile-home-component3"
    />
    <div class="mobile-home-frame79">
      <span class="mobile-home-text71 Mob,H3,Medium12" (click)="goLogin()">
        <span>Login</span>
      </span>
    </div>
  </div>
  <div class="mobile-home-header">
    <div class="mobile-home-frame120">
      <img  (click)="goHome()"
        alt="VectorI2776"
        src="/assets/external/mobile/vectori2776-m31m.svg"
        class="mobile-home-vector2"
      />
      <div class="mobile-home-frame108">
        <div class="mobile-home-icon"></div>
        <span class="mobile-home-text73 Mob,H1,Bold,14">
          <span>
            Paso 2 de 5
          </span>
        </span>
        <div class="mobile-home-icon1"></div>
      </div>
    </div>
  </div>
  <span class="mobile-home-text75">
    <span>Politica de privacidad</span>
  </span>
</div> -->